import React, { FC } from 'react'
import { Link } from 'react-router-dom'

import { UseFormWizardReturnType } from './useFormWizard'

import { Button } from 'Components/Button'
import { Icon, IconColor, IconName } from 'Components/Icon'
import { IconButton } from 'Components/IconButton'
import { StepIndicator, StepIndicatorProps } from 'Components/StepIndicator'
import { routes } from 'Config'

export type FormWizardProps = Pick<
  UseFormWizardReturnType<never>,
  'currentStep' | 'currentStepIndex' | 'canGoBack' | 'isLastStep'
> &
  Pick<StepIndicatorProps, 'knownNumberOfSteps' | 'totalNumberOfSteps'> & {
    isRestart: boolean
    isSubmitting: boolean
    lastStepButtonText?: string
    onSubmit: React.FormEventHandler
    onGoBack: React.MouseEventHandler
    showBackButton: boolean
    showSubmitButton: boolean
    startButtonText?: string
  }

export const FormWizard: FC<FormWizardProps> = ({
  isRestart,
  children,
  currentStep,
  currentStepIndex,
  knownNumberOfSteps,
  totalNumberOfSteps,
  canGoBack,
  isLastStep,
  isSubmitting,
  lastStepButtonText = 'Programm starten',
  onGoBack,
  onSubmit,
  showBackButton,
  showSubmitButton,
  startButtonText
}) => {
  return (
    <form name={currentStep.id} onSubmit={onSubmit} noValidate>
      <div className="container max-700 form-wizard-header">
        {isRestart && (
          <div className="form-wizard-close">
            <Link
              to={routes.settings.program}
              className={`d-flex iconbutton button-${IconName.close}`}
              title="Abbrechen"
              aria-label="Abbrechen"
            >
              <Icon name={IconName.close} color={IconColor.GRAY_1} />
            </Link>
          </div>
        )}

        <StepIndicator
          currentStep={currentStepIndex + 1}
          knownNumberOfSteps={knownNumberOfSteps}
          totalNumberOfSteps={totalNumberOfSteps}
        />
      </div>

      <div className="container max-700">
        <div className="row">
          <div className="col-12">
            {isRestart && !isLastStep && (
              <div className="basiccard p-3 mb-4">
                <h1>Programm Neustart</h1>
                <p>
                  Sie haben sich für einen Neustart entschieden. Um Ihnen den Prozess zu erleichtern, ist der Fragebogen
                  mit den Werten Ihres letzten Programmes bereits ausgefüllt.
                </p>
              </div>
            )}
            {currentStep.infoTextElement ? (
              <div className="basiccard p-3 mb-4">{currentStep.infoTextElement}</div>
            ) : null}
          </div>
        </div>

        <div className="basiccard p-3 mb-4">{children}</div>

        <div className="row align-items-center justify-content-between">
          <div className="col-auto col-md-6">
            {canGoBack && showBackButton && (
              <div className="form-wizard-back">
                <IconButton
                  name={IconName.arrowleft}
                  color={IconColor.GRAY_1}
                  onClick={onGoBack}
                  aria-label="Zurück"
                  linkTitle="Zurück"
                />
              </div>
            )}
          </div>

          <div className="col col-md-6">
            {showSubmitButton && (
              <Button type="submit" disabled={isSubmitting}>
                {isLastStep ? lastStepButtonText : startButtonText ?? 'Weiter'}
              </Button>
            )}
          </div>
        </div>
      </div>
    </form>
  )
}
